/**
 * Formata uma data no fuso-horário do usuário de acordo com o formato especificado.
 * @param {string} cTitle 
 */
export function getDocumentTitle(cTitle) {
  return cTitle && cTitle.trim() !== '' ? cTitle : 'Documento sem título';
};
